import script from "./PaymentCancellation.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentCancellation.vue?vue&type=script&setup=true&lang=js"

import "./PaymentCancellation.vue?vue&type=style&index=0&id=49c5806a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49c5806a"]])

export default __exports__